import { AppReducer } from './Reducers';
import { AppState } from './States';
import { appActions } from './Actions';
import { createStore } from './Store';

const [AppContextProvider, useAppDispatch, useAppStore] = createStore(
  AppReducer,
  AppState,
  appActions
);

export { AppContextProvider, useAppDispatch, useAppStore };
